<template>

    <div class="nk-header nk-header-fixed is-light  nk-header-fixed">
        <div class="container-lg wide-xl" style="max-width: 100% !important;">
            <div class="nk-header-wrap">
                <div class="nk-header-brand">
                    <a href="#" class="logo-link">
                        <img class="logo-light logo-img" :src="base_url + 'images/logo.png'" alt="logo">
                        <img class="logo-dark logo-img" :src="base_url + 'images/logo-dark.png'" alt="logo-dark">
                    </a>
                </div>
               
                <div class="nk-header-tools">
                    <ul class="nk-quick-nav">
                        <li v-if="ismobile==false && ldata!=null && ldata.type==='user'">
                            <a href="/settings" class="btn btn-lg btn-outline-success" style="padding-left:1.85rem; border-radius: .5rem; width: 100%;"><i class="fas fa-user-shield"></i>&nbsp;&nbsp;
                                <span  class="ng-scope">Upgrade to Pro</span>
                            </a>
                        </li>
                        <li class="dropdown notification-dropdown">
                            <a href="#" class="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown">
                                <div class="icon-status icon-status-info">
                                    <em class="icon ni ni-bell"></em>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-xl dropdown-menu-end dropdown-menu-s1">
                                <div class="dropdown-head">
                                    <span class="sub-title nk-dropdown-title">Notifications</span>
                                    <a href="#">Mark All as Read</a>
                                </div>
                                <div class="dropdown-body">
                                    <div class="nk-notification">
                                        <div class="nk-notification-item dropdown-inner"  v-for="user in notis" :key="user">
                                            <div class="nk-notification-icon">
                                                <em class="icon icon-circle bg-warning-dim ni ni-curve-down-right"></em>
                                            </div>
                                            <div class="nk-notification-content">
                                                <div class="nk-notification-text">
                                                    {{ user.title }}
                                                </div>
                                                <div class="nk-notification-time">{{ get_dur(user.datetime) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="dropdown-foot center">
                                    <a href="#">View All</a>
                                </div> -->
                            </div>
                        </li>
                        <li class="dropdown user-dropdown">
                            <a href="#" class="dropdown-toggle me-lg-n1" data-bs-toggle="dropdown">
                                <div class="user-toggle">
                                    <div class="user-avatar sm" style="background-color:#1ee0ac !important;">
                                        <em class="icon ni ni-user-alt"></em>
                                    </div>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1">
                                <div class="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                                    <div class="user-card">
                                        <div class="user-avatar" style="background-color:#1ee0ac !important;">
                                            <span v-if="ldata!=null && ldata!=undefined">{{ ldata.name.charAt(0) }}</span>
                                        </div>
                                        <div class="user-info">
                                            <span class="lead-text" v-if="ldata!=null && ldata!=undefined">{{ ldata.name }}</span>
                                            <span class="sub-text" v-if="ldata!=null && ldata!=undefined">{{ ldata.email }}</span>
                                        </div>
                                        <div class="user-action">
                                            <!-- <a class="btn btn-icon me-n2" href="#"> -->
                                                <!-- <em class="icon ni ni-setting"></em> -->
                                            <!-- </a> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="dropdown-inner">
                                    <ul class="link-list">
                                        <!-- <li>
                                            <a href="/settings">
                                                <em class="icon ni ni-user-alt"></em>
                                                <span>View Profile</span>
                                            </a>
                                        </li> -->
                                        <li v-if="ldata!=null && ldata.type==='user'">
                                            <a href="/settings">
                                                <em class="icon ni ni-setting-alt"></em>
                                                <span>Account Setting</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="dropdown-inner">
                                    <ul class="link-list">
                                        <li>
                                            <a href="/login">
                                                <em class="icon ni ni-signout"></em>
                                                <span>Sign out</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        <li class="d-lg-none">
                            <a href="#" class="toggle nk-quick-nav-icon me-n1" data-target="sideNav">
                                <em class="icon ni ni-menu"></em>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mainBaseUrl } from '@/apis/appconst';
import { getNotiList } from '@/apis/webapis';

export default {
    name: 'MainHeader',
    methods: {
        async getListNow($page_no) {
          this.page_no = $page_no;
          const response = await getNotiList(this.page_no,this.count,this.ldata.user_id);
          if (response.status) {
            this.notis = response.records;
          }
        },
        get_dur(datetime){
            const now = new Date();
            const targetDate = new Date(datetime);

            let diffMs = Math.abs(now - targetDate);

            const seconds = Math.floor(diffMs / 1000);
           
            if (seconds >= 2592000) {
                const months = Math.floor(seconds / 2592000);
                return `${months} month${months !== 1 ? 's' : ''}`;
            } else if (seconds >= 86400) {
                const days = Math.floor(seconds / 86400);
                return `${days} day${days !== 1 ? 's' : ''}`;
            } else if (seconds >= 3600) {
                const hours = Math.floor(seconds / 3600);
                return `${hours} hour${hours !== 1 ? 's' : ''}`;
            } else if (seconds >= 60) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
            } else {
                return `${seconds} second${seconds !== 1 ? 's' : ''}`;
            }
        },
        check_mob(){
          this.screen_width = window.innerWidth;
          if(this.screen_width<1400){
            this.ismobile = true;
           }
          else{
            this.ismobile = false;
           }
      }
    },
    data() {
        return {
            base_url: "",
            ldata:null,
            ismobile:false,
            notis:[]
        };
    },
    mounted() {
        this.check_mob();
        this.base_url = mainBaseUrl;
        if (sessionStorage.getItem("ldata") && sessionStorage.getItem("ldata").length > 0) {
            this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
        }
    },
}
</script>

